import { render, staticRenderFns } from "./IncomeInfo.vue?vue&type=template&id=66f193b0&"
import script from "./IncomeInfo.vue?vue&type=script&lang=js&"
export * from "./IncomeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports